import HomePage from 'screens/Home/Home';

export default HomePage;
